import type { ArgsOf, RequestOf } from "../../../access/types.ts";
import { Access } from "../../../access/types.ts";

export const McpAccesses = {
  role: Access({
    delegation: {},
    description:
      "Grant a named MCP role that allows calling specific tools on MCP server backends",
    label: "Role",
    maturity: "preview",
    generated: {},
    parameters: {
      name: {
        type: "static",
        label: "Role name",
        description: "The MCP role",
      },
    } as const,
    render: { locator: "name" } as const,
  }),
};

export type McpAccesses = typeof McpAccesses;
export type McpRoleAccess = McpAccesses["role"];
export type McpRoleRequest = RequestOf<McpRoleAccess>;
export type McpRoleAccessArgs = ArgsOf<McpRoleAccess>;
